import { cn } from "@/lib/utils";
import { Link } from "@tanstack/react-router";
import type { LinkProps } from "@tanstack/react-router";
import { FileText } from "lucide-react";

export function FileName({
  filename,
  className,
  linkProps,
  variant = "default",
}: {
  filename: string;
  className?: string;
  linkProps?: Partial<LinkProps> | null;
  variant?: "outline" | "default";
}) {
  if (linkProps) {
    return (
      <Link
        {...linkProps}
        className={cn(
          "hover:underline font-mono font-thin text-primary-foreground/80",
          "px-1 py-0.5 rounded truncate inline-flex gap-0.5",
          "items-center",
          variant === "outline"
            ? "bg-muted/70 border border-border"
            : "bg-muted",
          className,
        )}
      >
        <FileText className="w-4 h-4 flex-shrink-0 text-muted-foreground" />
        {filename || "file"}
      </Link>
    );
  }
  return (
    <code
      className={cn(
        "font-mono bg-muted font-thin text-primary-foreground/80 px-1 py-0.5 rounded truncate",
        className,
      )}
    >
      {filename || "file"}
    </code>
  );
}
